import React from 'react';
import { Typography } from '@app/ui';
import { useTranslation } from 'react-i18next';

import { User } from '@app/types/api';

import connect from '@app/utils/connect';
import combineActions from '@app/utils/combineActions';
import sendNotification from '@app/actions/notifications/send';

import { CardWithActions } from '@app/components/common/CardWithActions';

import { usePasswordform } from '@app/settings/hooks/usePasswordForm';
import { SETTINGS_TABS } from '@app/settings/constants/tabs';
import PasswordForm from './PasswordForm';

export type PasswordProps = {
    user: User;
    sendNotification: (msg: string, opts?: any) => void;
};

export const Password = ({ user, sendNotification }: PasswordProps) => {
    const { t } = useTranslation('settings');
    const {
        formik,
        savePassword,
        isSaveDisabled,
        clearAllFields,
        checkPasswordStrength,
        percent,
        passwordStatus,
    } = usePasswordform(user, sendNotification);

    return (
        <div className="user-settings-password">
            <Typography.Title
                style={{
                    fontWeight: 600,
                    fontSize: 16,
                    marginTop: '0.5em',
                    marginBottom: '1.5em',
                }}
            >
                {t('userSettings.password.title')}
            </Typography.Title>

            <CardWithActions
                actions={{
                    onCancel: {
                        label: t('userSettings.password.actions.clearAll'),
                        method: clearAllFields,
                    },
                    onConfirm: {
                        label: t('userSettings.password.actions.savePassword'),
                        method: savePassword,
                        isDisabled: isSaveDisabled,
                    },
                }}
                title={t('userSettings.password.cardTitle')}
                icon={SETTINGS_TABS.PASSWORD.iconDef}
            >
                <PasswordForm
                    formInstance={formik}
                    checkPasswordStrength={checkPasswordStrength}
                    percent={percent}
                    passwordStatus={passwordStatus}
                />
            </CardWithActions>
        </div>
    );
};

export default connect(
    ['user'],
    combineActions({ sendNotification }),
)(Password);
